import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { NextBestActionClickTrackingEvent, TrackingEventName } from "./tracking";

interface TrackNextBestActionClickFunctionArgs {
  readonly slug?: string;
}

interface TrackNextBestActionClickFunction {
  (args: TrackNextBestActionClickFunctionArgs): void;
}

interface UseTrackNextBestActionClickFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly customerId: string;
  readonly tradename: Tradename;
}

interface UseTrackNextBestActionClickFunction {
  (agrs: UseTrackNextBestActionClickFunctionArgs): TrackNextBestActionClickFunction;
}

const useTrackNextBestActionClick: UseTrackNextBestActionClickFunction = ({
  country,
  segment,
  customerId,
  tradename,
}) => {
  const emitUserEvent = useEmitUserEvent<NextBestActionClickTrackingEvent>();

  const trackNextBestActionClick: TrackNextBestActionClickFunction = useCallback(
    ({ slug }) =>
      emitUserEvent({
        event: TrackingEventName.NEXT_BEST_ACTION_CLICK,
        eventCategory: TrackingEventCategory.NAVIGATION,
        section: "myLK_Order",
        store: country,
        segment,
        userId: customerId,
        originNba: slug,
        tradename,
      }),
    [country, customerId, emitUserEvent, segment, tradename],
  );

  return trackNextBestActionClick;
};

export { useTrackNextBestActionClick };
